<template>
  <div class="contenedor-padre-rasgado">
    <!-- CAPA CON MÁSCARA SVG -->
    <div class="seccion-rasgada">
      <!-- SVG MASK INTERNO -->
      <svg width="0" height="0" class="svg-mask-element">
        <defs>
          <mask id="paper-mask-subtle" maskUnits="objectBoundingBox" maskContentUnits="objectBoundingBox">
            <path
              d="M 0,0.012 
                 C 0.1,0.005 0.2,0.018 0.35,0.008 
                 C 0.5,0.018 0.65,0.005 0.8,0.012 
                 C 0.9,0.005 0.95,0.015 1,0.008 
                 L 1,0.992 
                 C 0.88,0.995 0.75,0.985 0.6,0.992 
                 C 0.45,0.985 0.3,0.995 0.15,0.988 
                 C 0.08,0.992 0.03,0.988 0,0.992 Z"
              fill="#ffffff"
            />
          </mask>
        </defs>
      </svg>

      <!-- LÍNEAS DECORATIVAS EN EL FONDO -->
      <img :src="lineasImg" alt="" class="linea-ondulada linea-1" ref="linea1Ref" />
      <img :src="lineasImg" alt="" class="linea-ondulada linea-2" ref="linea2Ref" />
      <img :src="lineasImg" alt="" class="linea-ondulada linea-3" ref="linea3Ref" />
      <img :src="lineasImg" alt="" class="linea-ondulada linea-4" ref="linea4Ref" />
      <img :src="lineasImg" alt="" class="linea-ondulada linea-5" ref="linea5Ref" />

      <!-- FOTOS (Por encima de las líneas) -->
      <div class="contenido-vertical">
        <!-- FOTO 1 -->
        <div class="reveal-container rev-1">
          <div class="foto-wrapper" ref="foto1Ref">
            <img :src="img1" alt="Foto 1 Editorial" class="foto-elegante" />
          </div>
        </div>

        <!-- FOTO 2 -->
        <div class="reveal-container rev-2">
          <div class="foto-wrapper" ref="foto2Ref">
            <img :src="img2" alt="Foto 2 Editorial" class="foto-elegante" />
          </div>
        </div>

        <!-- FOTO 3 -->
        <div class="reveal-container rev-3">
          <div class="foto-wrapper" ref="foto3Ref">
            <img :src="img3" alt="Foto 3 Editorial" class="foto-elegante" />
          </div>
        </div>

        <!-- FOTO 4 -->
        <div class="reveal-container rev-4">
          <div class="foto-wrapper" ref="foto4Ref">
            <img :src="img4" alt="Foto 4 Editorial" class="foto-elegante" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import img1 from '@/assets/8_11zon.webp'
import img2 from '@/assets/9_11zon.webp'
import img3 from '@/assets/10_11zon.webp'
import img4 from '@/assets/11_11zon.webp'

import lineasImg from '@/assets/lineas.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'SeccionEleganteVertical',
  setup() {
    const foto1Ref = ref(null)
    const foto2Ref = ref(null)
    const foto3Ref = ref(null)
    const foto4Ref = ref(null)

    const linea1Ref = ref(null)
    const linea2Ref = ref(null)
    const linea3Ref = ref(null)
    const linea4Ref = ref(null)
    const linea5Ref = ref(null)

    let ctx = null

    onMounted(async () => {
      await nextTick()

      ctx = gsap.context(() => {
        // FOTO 1: Revelado vertical más gradual
        const tl1 = gsap.timeline({
          scrollTrigger: {
            trigger: '.rev-1',
            start: 'top 85%',    // Empieza más abajo para que sea visible
            end: 'top 30%',      // Termina más arriba, más gradual
            scrub: 1.5,          // Más suave
            invalidateOnRefresh: true
          }
        })
        tl1.fromTo('.rev-1',
          { clipPath: 'inset(0% 0% 100% 0%)' },
          { clipPath: 'inset(0% 0% 0% 0%)', ease: 'power1.out' }
        )
        .fromTo(foto1Ref.value,
          { scale: 1.25, filter: 'blur(12px)', opacity: 0.4 },
          { scale: 1, filter: 'blur(0px)', opacity: 1, ease: 'power1.out' },
          '<'
        )

        // FOTO 2: Entrada desde abajo con efecto elegante
        gsap.fromTo(foto2Ref.value,
          { y: 120, opacity: 0, rotationX: 20, scale: 0.85, filter: 'blur(10px)' },
          {
            y: 0, opacity: 1, rotationX: 0, scale: 1, filter: 'blur(0px)',
            ease: 'power2.out',
            scrollTrigger: {
              trigger: '.rev-2',
              start: 'top 85%',
              end: 'top 30%',
              scrub: 1.5,
              invalidateOnRefresh: true
            }
          }
        )

        // FOTO 3: Revelado horizontal en vivo
        const tl3 = gsap.timeline({
          scrollTrigger: {
            trigger: '.rev-3',
            start: 'top 85%',
            end: 'top 30%',
            scrub: 1.5,
            invalidateOnRefresh: true
          }
        })
        tl3.fromTo('.rev-3',
          { clipPath: 'inset(0% 100% 0% 0%)' },
          { clipPath: 'inset(0% 0% 0% 0%)', ease: 'power1.out' }
        )
        .fromTo(foto3Ref.value,
          { x: '-25%', filter: 'blur(10px)', opacity: 0.5 },
          { x: '0%', filter: 'blur(0px)', opacity: 1, ease: 'power1.out' },
          '<'
        )

        // FOTO 4: Escalado progresivo de entrada
        gsap.fromTo(foto4Ref.value,
          { y: 120, opacity: 0, scale: 0.8, filter: 'blur(10px)', rotationX: 15 },
          {
            y: 0, opacity: 1, scale: 1, filter: 'blur(0px)', rotationX: 0,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: '.rev-4',
              start: 'top 85%',
              end: 'top 30%',
              scrub: 1.5,
              invalidateOnRefresh: true
            }
          }
        )

        // LÍNEAS DECORATIVAS - entrada más temprana
        const lineasArr = [
          { ref: linea1Ref, delay: 0.1 },
          { ref: linea2Ref, delay: 0.3 },
          { ref: linea3Ref, delay: 0.5 },
          { ref: linea4Ref, delay: 0.2 },
          { ref: linea5Ref, delay: 0.4 }
        ]

        lineasArr.forEach(({ ref }) => {
          const linea = ref.value
          if (!linea) return

          gsap.fromTo(linea,
            {
              clipPath: 'inset(0% 100% 0% 0%)',
              opacity: 0,
              filter: 'blur(6px)',
              x: -30
            },
            {
              clipPath: 'inset(0% 0% 0% 0%)',
              opacity: 0.5,
              filter: 'blur(0px)',
              x: 0,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: linea,
                start: 'top 85%',
                end: 'top 30%',
                scrub: 1.5
              }
            }
          )
        })

        // Refresh después de un momento
        setTimeout(() => {
          ScrollTrigger.refresh()
        }, 500)
      })
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return {
      img1, img2, img3, img4, lineasImg,
      foto1Ref, foto2Ref, foto3Ref, foto4Ref,
      linea1Ref, linea2Ref, linea3Ref, linea4Ref, linea5Ref
    }
  }
}
</script>

<style scoped>
.contenedor-padre-rasgado {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.seccion-rasgada {
  position: relative;
  background:
    linear-gradient(
      rgba(255, 255, 255, 0.85),
      rgba(255, 255, 255, 0.45)
    ),
    url('@/assets/codigo.jpg') center center / cover no-repeat;
  width: 100%;
  padding: 90px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  mask: url(#paper-mask-subtle);
  -webkit-mask: url(#paper-mask-subtle);
  mask-size: 100% 100%;
  -webkit-mask-size: 100% 100%;
}

.svg-mask-element {
  position: absolute;
  width: 0;
  height: 0;
  pointer-events: none;
}

/* LÍNEAS DECORATIVAS EN EL FONDO */
.linea-ondulada {
  position: absolute;
  width: min(80vw, 880px) !important;
  height: auto;
  object-fit: contain;
  pointer-events: none;
  z-index: 1;
  will-change: clip-path, opacity, filter, transform;
}

.linea-1 {
  top: 8%;
  left: 2%;
  transform: rotate(-10deg);
}

.linea-2 {
  top: 28%;
  right: 2%;
  transform: rotate(15deg) scaleX(-1);
}

.linea-3 {
  top: 48%;
  left: 3%;
  transform: rotate(-5deg);
}

.linea-4 {
  top: 68%;
  right: 2%;
  transform: rotate(12deg) scaleX(-1);
}

.linea-5 {
  top: 88%;
  left: 4%;
  transform: rotate(-15deg);
}

/* CONTENEDOR DE FOTOS */
.contenido-vertical {
  position: relative;
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 65px;
  z-index: 5;
  perspective: 1200px;
}

.reveal-container {
  width: 100%;
  overflow: hidden;
  will-change: clip-path;
}

.foto-wrapper {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 16px 38px -10px rgba(0, 0, 0, 0.16);
  backface-visibility: hidden;
  transform-style: preserve-3d;
}

.foto-elegante {
  width: 100%;
  height: 520px;
  display: block;
  object-fit: cover;
  will-change: transform, opacity, filter;
  transform: translateZ(0);
}

@media (max-width: 420px) {
  .foto-elegante {
    height: 460px;
  }

  .linea-ondulada {
    width: min(45vw, 140px);
  }
}

/* Ajustes adicionales para móvil */
@media (max-width: 768px) {
  .seccion-rasgada {
    padding: 60px 16px;
  }
  
  .contenido-vertical {
    gap: 45px;
    max-width: 360px;
  }
  
  .foto-elegante {
    height: 380px;
  }
}
</style>